import React, { useRef, useState, useEffect } from 'react';
import './TermsViewer.scss';

function TermsViewer() {
    const iframeRef = useRef(null);
    const [isScrolledToBottom, setIsScrolledToBottom] = useState(false);

    const handleClose = () => {
        window.close();
    };

    useEffect(() => {
        const iframe = iframeRef.current;
        if (!iframe) return;

        const handleIframeLoad = () => {
            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            const iframeWindow = iframe.contentWindow;

            const checkScrollPosition = () => {
                if (iframeDocument && iframeWindow) {
                    const scrollTop = iframeWindow.scrollY || iframeDocument.documentElement.scrollTop;
                    const scrollHeight = iframeDocument.documentElement.scrollHeight;
                    const clientHeight = iframeWindow.innerHeight || iframeDocument.documentElement.clientHeight;
                    const isAtBottom = scrollHeight - scrollTop - clientHeight < 10; // 10px tolerance
                    setIsScrolledToBottom(isAtBottom);
                }
            };

            iframeWindow.addEventListener('scroll', checkScrollPosition);
            return () => iframeWindow.removeEventListener('scroll', checkScrollPosition);
        };

        iframe.addEventListener('load', handleIframeLoad);
        return () => iframe.removeEventListener('load', handleIframeLoad);
    }, []);

    return (
        <div className="terms-viewer-container">
            <div className="terms-content">
                <iframe
                    ref={iframeRef}
                    src="/Terms.html"
                    title="Terms of Use"
                    className="terms-iframe"
                />
            </div>
            <div className="terms-footer">
                {!isScrolledToBottom && (
                    <p className="scroll-notice">Please scroll down to review the full terms before continuing.</p>
                )}
                <button
                    className="btn-next"
                    onClick={handleClose}
                    disabled={!isScrolledToBottom}
                >
                    NEXT
                </button>
            </div>
        </div>
    );
}

export default TermsViewer;
